var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#7346FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 21.289H19.8033C19.07 21.289 18.3733 21.5732 17.86 22.0865L16.2925 23.6357C15.5775 24.3415 14.4133 24.3415 13.6983 23.6357L12.1308 22.0865C11.6175 21.5732 10.9117 21.289 10.1875 21.289H9.5C7.97833 21.289 6.75 20.0698 6.75 18.5665V8.55648C6.75 7.05315 7.97833 5.83398 9.5 5.83398H20.5C22.0217 5.83398 23.25 7.05315 23.25 8.55648V18.5573C23.25 20.0607 22.0217 21.289 20.5 21.289Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0679 12.2059C15.0312 12.2059 14.9762 12.2059 14.9304 12.2059C13.9679 12.1692 13.207 11.39 13.207 10.4184C13.207 9.42836 14.0045 8.63086 14.9945 8.63086C15.9845 8.63086 16.7821 9.43753 16.7821 10.4184C16.7912 11.39 16.0304 12.1784 15.0679 12.2059Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4808 14.9648C11.2616 15.7807 11.2616 17.1098 12.4808 17.9257C13.8649 18.8515 16.1383 18.8515 17.5224 17.9257C18.7416 17.1098 18.7416 15.7807 17.5224 14.9648C16.1383 14.0482 13.8741 14.0482 12.4808 14.9648Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPic);
export default __webpack_public_path__ + "static/media/chat-pic.b0b2d6362aa9cbe90137ea2232ef301f.svg";
export { ForwardRef as ReactComponent };